import Box from '@mui/material/Box'
import NavBar from '../components/NavBar'

const Terms = () => {
  return (
    <>
      <NavBar />
      <Box
        component={'iframe'}
        src="https://adnexio-hr-prod.s3.ap-southeast-1.amazonaws.com/terms_and_conditions/main/adnexioHR_tnc_20221214.pdf"
        title="adnexio HR terms and conditions"
        sx={{
          width: '100%',
          height: { xs: 'calc(100vh - 60px)', md: 'calc(100vh - 80px)' },
          p: 0,
          m: 0,
          border: 'none',
        }}
      />
    </>
  )
}

export default Terms
